import React from "react";
import { VacancyApplication } from "../../../model/VacancyApplicant.interface";
import BFIndicatorOverlay, {
  BFIndicatorOverlayLevel,
} from "@/modules/abstract-ui/general/IndicatorOverlay/BFIndicatorOverlay";
import { ActivityApplicationConstants } from "@/apps/tatar/activityApp/ActivityHooks";
import VacancyApplicantCreditReportPart from "./VacancyApplicantCreditReportPart";

type Props = {
  application: VacancyApplication;
  applicantId: string;
  constants: ActivityApplicationConstants;
  editable?: boolean;
};

const VacancyApplicantCreditReportStatus = (props: Props) => {
  const { application, applicantId, constants, editable = false } = props;

  const applicant = application.data.applicants.find(
    (c) => c.id === applicantId
  );

  const calculateLevelFromScore = (): BFIndicatorOverlayLevel => {
    const score = applicant.creditWorthiness;
    if (score === undefined) {
      return "warn";
    }

    switch (score) {
      case "full":
        return "full";
      case "limited":
        return "partially";
      case "none":
        return "warn";
    }
  };

  const level = calculateLevelFromScore();

  const renderSpeaker = (close: () => void) => {
    return (
      <VacancyApplicantCreditReportPart
        editable={editable}
        application={application}
        applicant={applicant}
        constants={constants}
        onChanged={close}
      />
    );
  };

  return (
    <BFIndicatorOverlay
      placement="left"
      speakerFC={renderSpeaker}
      level={level}
    />
  );
};

export default VacancyApplicantCreditReportStatus;
